import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";
import { Suspense } from "react";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return (
    <Suspense
      fallback={
        <div className="flex h-screen bg-background text-foreground">
          <div className="w-64 bg-card border-r border-gray-200 animate-pulse" />
          <div className="flex-1 flex flex-col">
            <div className="h-[93px] border-b border-gray-200 bg-white animate-pulse" />
            <main className="flex-1 overflow-auto p-6">
              <div className="h-6 w-48 bg-gray-200 rounded mb-4 animate-pulse"></div>
              <div className="h-4 w-72 bg-gray-200 rounded mb-8 animate-pulse"></div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="h-32 bg-gray-100 rounded animate-pulse"></div>
                <div className="h-32 bg-gray-100 rounded animate-pulse"></div>
                <div className="h-32 bg-gray-100 rounded animate-pulse"></div>
              </div>
            </main>
          </div>
        </div>
      }
    >
      {element}
    </Suspense>
  );
}